/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Geofences Radial Icon component.
 */
export const GeofencesRadialIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='GeofencesRadialIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 22 22' fill='none'>
        <circle cx='11.0001' cy='10.9991' r='9.47368' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      </svg>
    )} />
  );
};
